<template>
  <div
    class="carousel-third"
    :style="{
      backgroundImage:
        'url(' + require('@/assets/images/index/carousel-3.jpg') + ')',
    }"
  >
    <div class="carousel-content">
      <div class="carousel-header">
        <div class="header-title">{{ $t("index.information") }}</div>
        <div class="header-tips">{{ $t("index.informationTips") }}</div>
      </div>
      <div class="slider-info">
        <div class="carousel-slider">
          <el-carousel trigger="click" height="420px">
            <el-carousel-item
              v-for="(item, index) in carouselList"
              :key="index"
            >
              <img class="slider-img" :src="item.thumb" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="carousel-info">
          <div
            v-for="(item, index) in list.slice(0, 4)"
            :key="index"
            class="info-item transition"
            @click="toDetail(item)"
          >
            <div class="info-title transition">
              {{ item.title }}
            </div>
            <div class="info-desc transition">
              {{ item.brief }}
            </div>
            <div class="flex-sub"></div>
            <div class="info-footer">
              <div class="info-time transition">{{ item.publishTime }}</div>
              <div class="footer-icon transition"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGuides } from "@/api/index";
import { getNewsPage } from "@/api/common";

export default {
  data() {
    return {
      carouselList: [],
      list: [],
    };
  },
  created() {
    getGuides({ parentId: "1840677723522097153" }).then((res) => {
      this.carouselList = res.data.records;
    });
    getNewsPage(
      {
        categoryId: "1838757870246817794",
        descs: "publish_time",
      },
      {
        language: "CN",
      }
    ).then((res) => {
      this.list = res.data.records;
    });
  },
  methods: {
    toDetail(row) {
      if (row.externalUrl) {
        window.open(row.externalUrl);
      } else {
        this.$router.push("/information/detail?id=" + row.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-third {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100%;
  .carousel-content {
    padding-top: 88px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .carousel-header {
    text-align: center;
    .header-title {
      margin-top: 90px;
      color: #fff;
      font-size: 48px;
      font-weight: 700;
      line-height: 26px;
      letter-spacing: 4.32px;
    }
    .header-tips {
      margin-top: 36px;
      color: #fff;
      font-size: 18px;
      font-weight: 400;
      line-height: 26px;
      letter-spacing: 1.62px;
    }
  }
  .slider-info {
    margin-top: 80px;
    display: flex;
    justify-content: center;
    .carousel-slider {
      width: 643px;
      .slider-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      ::v-deep {
        .el-carousel__indicators {
          .el-carousel__indicator--horizontal {
            .el-carousel__button {
              width: 10px;
              height: 10px;
              background-color: #ffffff;
              border-radius: 5px;
              opacity: 1;
            }
            &.is-active {
              .el-carousel__button {
                background: #009d94;
              }
            }
          }
        }
      }
    }
    .carousel-info {
      margin-left: 24px;
      width: 664px;
      display: grid;
      grid-row-gap: 24px;
      grid-column-gap: 24px;
      grid-template-columns: auto auto;
      grid-template-rows: minmax(185px, auto) minmax(185px, auto);

      .info-item {
        border-top: 4px solid #009d94;
        padding: 16px 20px 20px;
        background: #fff;
        display: flex;
        flex-direction: column;
        cursor: pointer;

        .info-title {
          color: #222;
          font-size: 18px;
          font-weight: 400;

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1; /* 显示的行数，可以根据需要修改 */
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .info-desc {
          margin-top: 9px;
          // flex: 1;
          flex-shrink: 0;
          color: #666;
          font-size: 14px;
          font-weight: 400;
          line-height: 26px; /* 185.714% */

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* 显示的行数，可以根据需要修改 */
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .info-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .info-time {
            color: #666;
            font-size: 14px;
            font-weight: 400;
            line-height: 26px; /* 185.714% */
          }
          .footer-icon {
            width: 20px;
            height: 20px;

            background-repeat: no-repeat;
            background-image: url(@/assets/images/index/arrow-green.png);
            background-size: 100%;
          }
        }
        &:hover {
          background: #009d94;
          .info-title,
          .info-desc,
          .info-time {
            color: #ffffff;
          }
          .footer-icon {
            background-image: url(@/assets/images/index/arrow-white.png);
          }
        }
      }
    }
  }
}
</style>
